export default __webpack_public_path__ + "static/media/maia-no-text-logo.b7a62db7.svg";